/**
 * 基盤スキーマ — 他のドメインスキーマから参照される共通定義
 */
import { z } from 'zod';
// ========================================
// 基盤 enum
// ========================================
/**
 * AI プロバイダー種別
 */
export const AIProviderTypeSchema = z.enum(['openai', 'anthropic', 'bedrock', 'google']);
/**
 * Reasoning モード
 */
export const ReasoningModeSchema = z.enum(['on', 'off']);
/**
 * タイトル生成エラーコード
 */
export const TitleErrorCodeSchema = z.enum([
    'VALIDATION_ERROR',
    'PROVIDER_NOT_AVAILABLE',
    'GENERATION_FAILED',
]);
// ========================================
// 共通 enum
// ========================================
/**
 * タスクステータス
 */
export const TaskStatusSchema = z.enum(['running', 'completed', 'error', 'interrupted']);
// ========================================
// 値オブジェクト
// ========================================
/**
 * トークン使用量
 */
export const TokenUsageSchema = z.object({
    input: z.number(),
    output: z.number(),
    reasoning: z.number().optional(),
    cacheRead: z.number().optional(),
    cacheWrite: z.number().optional(),
});
/**
 * コスト情報
 */
export const CostsSchema = z.object({
    total: z.number(),
    input: z.number().optional(),
    output: z.number().optional(),
    reasoning: z.number().optional(),
    cacheRead: z.number().optional(),
    cacheWrite: z.number().optional(),
});
/**
 * LLM 使用量
 */
export const UsageSchema = z.object({
    tokens: TokenUsageSchema,
    costs: CostsSchema.optional(),
});
// ========================================
// メッセージ
// ========================================
/**
 * メッセージパート
 */
export const MessagePartSchema = z
    .object({
    type: z.string(),
})
    .passthrough();
// ========================================
// モデル関連
// ========================================
/**
 * モデル情報
 */
export const ModelInfoSchema = z.object({
    provider: z.string(),
    modelId: z.string(),
    displayName: z.string().optional(),
});
/**
 * モデル選択（リクエストで使用）
 */
export const ModelSelectionSchema = z.object({
    provider: AIProviderTypeSchema,
    modelId: z.string(),
});
/**
 * トークン単価情報
 */
export const ModelPricingSchema = z.object({
    inputTokens: z.number(),
    outputTokens: z.number(),
    cachedTokens: z.number().optional(),
    cacheWriteTokens: z.number().optional(),
    reasoningTokens: z.number().optional(),
});
/**
 * モデル定義
 */
export const ModelDefinitionSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    provider: AIProviderTypeSchema,
    supportsReasoning: z.boolean(),
    supportsTools: z.boolean(),
    supportsVision: z.boolean().optional(),
    contextWindow: z.number(),
    pricing: ModelPricingSchema,
    region: z.string().optional(),
});
/**
 * プロバイダー情報（モデル一覧を含む）
 */
export const ProviderInfoSchema = z.object({
    type: AIProviderTypeSchema,
    available: z.boolean(),
    models: z.array(ModelDefinitionSchema),
});
// ========================================
// 汎用レスポンス
// ========================================
/**
 * 汎用成功レスポンス（PUT/DELETE の { success: true }）
 */
export const SimpleSuccessResponseSchema = z.object({ success: z.boolean() });
//# sourceMappingURL=base-schemas.js.map